import { FC, useState } from 'react';
import { IDish } from '../../../../types/dishes.types';
import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { COLORS, FONTS } from '../../../../constants';
import { Button } from '../../../../components/Button';
import { convertPrice } from '../../../../services/utils';
import RenderHTML from 'react-native-render-html';
import { htmlDecode } from '../../../../services/utils/htmlDecode';
import { STYLE_VARS } from '../../../../constants/style-vars';
import { IExtraDish } from '../../../../types/dishes.types';
import { IExtraActivity } from '../../../../types/activities.types';
import { isSameDate } from '../../../../services/utils/dateConvert';
import dayjs from 'dayjs';

interface AddtionalActivityItemProps {
  item: IExtraActivity;
  onUpdateAttendees: (activity: IExtraActivity, type: 'add' | 'minus') => void;
}

const AddtionalActivityItem: FC<AddtionalActivityItemProps> = ({
  item,
  onUpdateAttendees,
}) => {
  const handleAddPeople = () => {
    onUpdateAttendees(item, 'add');
  };

  const handleMinusPeople = () => {
    onUpdateAttendees(item, 'minus');
  };

  return (
    <View
      style={{
        width: '100%',
      }}
      key={`${item.activity.id}-${item.date}`}
    >
      <TouchableOpacity
        style={{
          marginBottom: 7,
        }}
        onPress={() => {}}
      >
        <Image
          source={
            item.activity.image
              ? {
                  uri: item.activity.image,
                }
              : require('../../../../assets/activities_image/image-1.png')
          }
          style={[
            {
              width: '100%',
              borderRadius: 18,
              height: 170,
            },
          ]}
        />
      </TouchableOpacity>
      <Text
        style={{
          fontFamily: FONTS.AvenirMedium,
          fontWeight: '800',
          fontSize: 19,
          color: COLORS.BLACK,
          marginBottom: 8,
        }}
      >
        {item.activity.name}
      </Text>
      <View
        style={{
          width: 60,
          height: 2,
          marginBottom: 12,
          backgroundColor: COLORS.RED_PRIMARY,
        }}
      />
      <View style={{ marginBottom: 5 }}>
        <View style={styles.timeWrapper}>
          <Text style={styles.timeText}>
            {`${dayjs(new Date(item.activity.start_time)).format(
              'hh:mm a'
            )} ~ ${dayjs(new Date(item.activity.end_time)).format('hh:mm a')}`}
          </Text>
        </View>
      </View>
      <View style={{ marginBottom: 5 }}>
        <Text style={styles.descriptionText}>{item.activity.venue}</Text>
      </View>
      <Text
        style={{
          fontFamily: FONTS.AvenirMedium,
          fontWeight: '800',
          fontSize: 19,
          color: COLORS.RED_PRIMARY,
          marginBottom: 5,
        }}
      >
        {`HKD ${convertPrice(item.activity.price)}`}
      </Text>
      <View style={{ marginBottom: 5 }}>
        <Text
          style={{
            fontFamily: FONTS.AvenirMedium,
            fontSize: 14,
            fontWeight: '500',
            color: COLORS.GREY,
          }}
        >
          {'Number Of People:'}
        </Text>
      </View>
      <View style={styles.countContainer}>
        <TouchableOpacity onPress={handleMinusPeople} activeOpacity={1}>
          <Image
            style={styles.countBtnIcon}
            source={require('../../../../assets/minus-red-icon.png')}
          />
        </TouchableOpacity>
        <Text
          style={{
            ...styles.countNumber,
            paddingHorizontal: 10,
          }}
        >
          {item.attendees}
        </Text>
        <TouchableOpacity activeOpacity={1} onPress={handleAddPeople}>
          <Image
            style={styles.countBtnIcon}
            source={require('../../../../assets/add-icon.png')}
          />
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default AddtionalActivityItem;

const styles = StyleSheet.create({
  countContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
  },
  countBtnIcon: {
    width: 20,
    height: 20,
  },
  countNumber: {
    fontSize: 12,
    color: COLORS.BLACK,
    fontFamily: STYLE_VARS.avenirMediumFont,
  },
  descriptionText: {
    fontFamily: FONTS.AvenirMedium,
    fontSize: 16,
    fontWeight: '500',
    color: COLORS.GREY,
  },
  timeWrapper: {
    borderRadius: 18,
    paddingVertical: 3,
    paddingHorizontal: 5,
    backgroundColor: COLORS.LIGHT_GREY,
    width: 130,
  },
  timeText: {
    fontFamily: FONTS.AvenirMedium,
    fontSize: 11,
    fontWeight: '500',
    color: COLORS.BLACK,
    textAlign: 'center',
    lineHeight: 18,
  },
});
